"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioPanner = void 0;

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var AudioPanner = /*#__PURE__*/function () {
  function AudioPanner() {
    var minpanpos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var maxpanpos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var minpanduration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var maxpanduration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var panNode = arguments.length > 4 ? arguments[4] : undefined;
    var audioContext = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, AudioPanner);

    this.minpanpos = minpanpos;
    this.maxpanpos = maxpanpos;
    this.minpanduration = minpanduration;
    this.maxpanduration = maxpanduration;
    this.panNode = panNode;
    this.audioContext = audioContext;
    this.updateParams();
    this.panNode.pan.value = (0, _utils.random)(this.minpanpos, this.maxpanpos);
  }

  _createClass(AudioPanner, [{
    key: "updateParams",
    value: function updateParams() {
      // when it's first time use random value for initial else use final
      this.finalPosition = (0, _utils.random)(this.minpanpos, this.maxpanpos);
      this.duration = (0, _utils.random)(this.minpanduration, this.maxpanduration);
      this.currentPosition = this.initialPosition;
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;

      this.panNode.pan.linearRampToValueAtTime(this.finalPosition, this.audioContext.currentTime + this.duration); //  create a timeout loop function

      this.timerId = setTimeout(function () {
        _this.updateParams();

        _this.start();
      }, this.duration * 1000);
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
    }
  }]);

  return AudioPanner;
}();

exports.AudioPanner = AudioPanner;